<template>
    <div class="vehicle-info">
        <!-- 标题与生成时间 -->
        <div class="no-page-break-before" ></div>
        <!-- <div v-else style="padding-top: 10px;"></div> -->
        <div class="header">
            <h3>二、车辆运行汇总数据</h3>
            <span class="generate-time">采集时间段： {{ beginDate }} ~ {{ endDate }}</span>

        </div>
        <div style="margin: 10px 0;">自车辆出厂以来，运行时长已达 {{ totalRunDuration }} ，运行里程已达 {{ totalMileage
        }} 公里，总燃料消耗已达 {{ totalElecConsume }} 。</div>
        <div>
            <!-- 车辆信息描述列表 -->
            <el-table :data="tableData" :cell-class-name="tableCellClassName" :span-method="arraySpanMethod"
                :show-header="false">
                <!-- 第一列：使用状态 -->
                <el-table-column prop="category" width="120" align="center" />
                <!-- 第二列：基本项目 -->
                <el-table-column prop="group" width="120" align="center" />
                <el-table-column prop="item" width="120" align="center" />
                <!-- 第三列：该时间段累计 -->
                <el-table-column prop="periodTotal" align="center" />
                <!-- 第四列：系统总累计 -->
                <el-table-column prop="systemTotal" align="center" />
            </el-table>
        </div>

        <div class="no-page-break-before" v-if="fuelType == 1"></div>
        <div v-else style="padding-top: 10px;"></div>
        <div>
            <el-table :data="tableData3" border :cell-class-name="tableCellClassName" :span-method="arraySpanMethod"
                :show-header="false" style="width: 100%;">
                <!-- 第一列：使用状态 -->
                <el-table-column prop="category" width="120" align="center" />
                <!-- 第二列：基本项目 -->
                <el-table-column prop="group" width="120" align="center" />
                <el-table-column prop="item" width="120" align="center" />
                <!-- 第三列：该时间段累计 -->
                <el-table-column prop="periodTotal" align="center" />
                <!-- 第四列：系统总累计 -->
                <el-table-column prop="systemTotal" align="center" />
            </el-table>
        </div>
        <div class="no-page-break-before"></div>
        <div>
            <el-table :data="tableData4" border :span-method="arraySpanMethod" :show-header="false" style="width: 100%;"
                :cell-class-name="tableCellClassName">
                <!-- 第一列：使用状态 -->
                <el-table-column prop="category" width="120" align="center" />
                <!-- 第二列：基本项目 -->
                <el-table-column prop="group" width="120" align="center" />
                <el-table-column prop="item" width="120" align="center" />
                <!-- 第三列：该时间段累计 -->
                <el-table-column prop="periodTotal" align="center" />
                <!-- 第四列：系统总累计 -->
                <el-table-column prop="systemTotal" align="center" />
            </el-table>
        </div>
        <div class="no-page-break-before"></div>
        <div>
            <el-table :data="tableData5" border :cell-class-name="tableCellClassName" :span-method="arraySpanMethod"
                :show-header="false" style="width: 100%;">
                <!-- 第一列：使用状态 -->
                <el-table-column prop="category" width="120" align="center" />
                <!-- 第二列：基本项目 -->
                <el-table-column prop="group" width="120" align="center" />
                <el-table-column prop="item" width="120" align="center" />
                <!-- 第三列：该时间段累计 -->
                <el-table-column prop="periodTotal" align="center" />
                <!-- 第四列：系统总累计 -->
                <el-table-column prop="systemTotal" align="center" />
            </el-table>
        </div>
        <div class="note-section">
            <el-card shadow="never" class="note-card">
                <div class="note-title">附注：</div>
                <div class="note-content">
                    1.本报告采集的数据来源分为三类：
                    <div class="note-sub-item">a.车辆基本信息中的总数据是车辆出厂运行后的总数据统计；</div>
                    <div class="note-sub-item">b.车辆运行汇总中时间段累计数据是报告时间段内的数据统计；</div>
                    <div class="note-sub-item">c.车辆运行汇总中系统总累计数据是车载电脑安装后总共采集到的数据统计；</div>
                    2.数据分析规定： 本数据的分析重点是时间段内的数据分析，总累计数据作为分析参考。
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
import { formatDuration } from '@/utils/longyi.js'
export default {
    name: "VehicleStatisticsTable",
    props: {
        vehicleStatus: {
            type: Object,
            default: () => ({})
        },
        fuelType: {
            type: Number,
            default: 1
        },
        beginDate: {
            type: String,
            default: ""
        },
        endDate: {
            type: String,
            default: ""
        },
    },
    watch: {
        vehicleStatus: {
            handler(newVal, oldVal) {
                // console.log("数据更新");
                // console.log(newVal!=undefined && newVal.period!=undefined && newVal.total!=undefined);
                this.generateTableData(newVal);
            },
            deep: true
        }
    },
    data() {
        return {
            totalMileage: 0.000,
            totalRunDuration: "00:00:00",
            totalElecConsume: "",
            tableData: [
            ],

            tableData3: [


            ],
            tableData4: [
                // 表头行



            ],
            tableData5: [
                // 表头行


            ]
        };
    },
    methods: {
        //计算时间占比
        calculateDurationRatio(periodDuration, totalDuration) {

            if (totalDuration == 0) {
                return "0%";
            }
            return (periodDuration / totalDuration * 100).toFixed(2) + "%";
        },
        // 生成表格数据
        generateTableData(vehicleStatus) {
            if (vehicleStatus != undefined && vehicleStatus.period != undefined && vehicleStatus.total != undefined) {
                this.totalMileage = vehicleStatus.total.RunMileage;
                this.totalRunDuration = formatDuration(vehicleStatus.total.RunDuration);
                this.totalElecConsume = this.fuelType == 1 ? (vehicleStatus.total.TotalElecConsume + " kwh") : (vehicleStatus.total.OilConsume + " L");
                // var temp_data=[];
                // temp_data.push({ category: "使用状态", group: "基本项目", item: "", periodTotal: "采集数据", systemTotal: "", isHeader: true });

                this.tableData = [
                    { category: "使用状态", group: "基本项目", item: "", periodTotal: "采集数据", systemTotal: "", isHeader: true },
                    { category: "", group: "", item: "", periodTotal: "该时间段累计", systemTotal: "系统总累计", isHeader: true },
                    {
                        category: "车辆运行状态", categoryRowspan: 5, item: "", group: "行驶里程(km)", groupColspan: 2, groupRowspan: 1,
                        periodTotal: vehicleStatus.period.RunMileage, systemTotal: vehicleStatus.total.RunMileage
                    },
                    {
                        category: "", item: "",
                        group: "平均速度(不含怠速)(km/h)", groupColspan: 2, groupRowspan: 1,
                        periodTotal: vehicleStatus.period.AvgSpeed,
                        systemTotal: vehicleStatus.total.AvgSpeed
                    },
                    {
                        category: "", item: "",
                        group: "平均速度(含怠速)(km/h)", groupColspan: 2, groupRowspan: 1,
                        periodTotal: vehicleStatus.period.AvgSpeedIdle,
                        systemTotal: vehicleStatus.total.AvgSpeedIdle
                    },
                    {
                        category: "", item: "", groupColspan: 2, groupRowspan: 1,
                        group: this.fuelType == 1 ? "电量累计消耗 (kwh)" : "燃油累计使用量 (L)",
                        periodTotal: this.fuelType == 1 ? vehicleStatus.period.TotalElecConsume : vehicleStatus.period.OilConsume,
                        systemTotal: this.fuelType == 1 ? vehicleStatus.total.TotalElecConsume : vehicleStatus.total.OilConsume
                    },

                    {
                        category: "", item: "", groupColspan: 2, groupRowspan: 1,
                        group: this.fuelType == 1 ? "平均电耗(kwh/100km)" : "平均油耗(L/100km)",
                        periodTotal: this.fuelType == 1 ? vehicleStatus.period.AvgElecConsume : vehicleStatus.period.PerOilConsume,
                        systemTotal: this.fuelType == 1 ? vehicleStatus.total.AvgElecConsume : vehicleStatus.total.PerOilConsume
                    },

                    // 电动机工作状态模块
                    {
                        category: this.fuelType == 1 ? "电动机工作状态" : "发动机工作状态", categoryRowspan: 4, item: "",
                        group: "运行时长(hh:mm:ss)", groupColspan: 2, groupRowspan: 1,
                        periodTotal: formatDuration(vehicleStatus.period.RunDuration),
                        systemTotal: formatDuration(vehicleStatus.total.RunDuration)
                    },
                    {
                        category: "", item: "",
                        group: "行驶时长(hh:mm:ss)", groupColspan: 2, groupRowspan: 1,
                        periodTotal: formatDuration(vehicleStatus.period.DriveDuration),
                        systemTotal: formatDuration(vehicleStatus.total.DriveDuration)
                    },
                    {
                        category: "", item: "",
                        group: "过长怠速时长 (hh:mm:ss)", groupColspan: 2, groupRowspan: 1,
                        periodTotal: formatDuration(vehicleStatus.period.OverIdleDuration),
                        systemTotal: formatDuration(vehicleStatus.total.OverIdleDuration)
                    },
                    {
                        category: "", item: "",
                        group: "过长怠速比例(%)", groupColspan: 2, groupRowspan: 1,
                        periodTotal: vehicleStatus.period.IdleRatio + "%",
                        systemTotal: vehicleStatus.total.IdleRatio + "%"
                    },
                    {
                        category: "驾驶员操作状态", item: "", categoryRowspan: 12,
                        group: "前门开启次数", groupColspan: 2, groupRowspan: 1,
                        periodTotal: vehicleStatus.period.FDoorCount,
                        systemTotal: vehicleStatus.total.FDoorCount
                    },
                    // 操作项数据
                    { category: "", item: "", groupColspan: 2, groupRowspan: 1, group: "前门异常开启次数(车速>5km/h)", periodTotal: vehicleStatus.period.OFDoorCount, systemTotal: vehicleStatus.total.OFDoorCount },
                    { category: "", item: "", groupColspan: 2, groupRowspan: 1, group: "中门开启次数", periodTotal: vehicleStatus.period.CDoorCount, systemTotal: vehicleStatus.total.CDoorCount },
                    { category: "", item: "", groupColspan: 2, groupRowspan: 1, group: "中门异常开启次数(车速>5km/h)", periodTotal: vehicleStatus.period.OCDoorCount, systemTotal: vehicleStatus.total.OCDoorCount },
                    { category: "", item: "", groupColspan: 2, groupRowspan: 1, group: "后门开启次数", periodTotal: vehicleStatus.period.BDoorCount, systemTotal: vehicleStatus.total.BDoorCount },
                    { category: "", item: "", groupColspan: 2, groupRowspan: 1, group: "后门异常开启次数(车速>5km/h)", periodTotal: vehicleStatus.period.OBDoorCount, systemTotal: vehicleStatus.total.OBDoorCount },
                    { category: "", item: "", groupColspan: 2, groupRowspan: 1, group: "倒挡次数", periodTotal: vehicleStatus.period.RGearCount, systemTotal: vehicleStatus.total.RGearCount },
                    { category: "", item: "", groupColspan: 2, groupRowspan: 1, group: "缓速器工作次数", periodTotal: vehicleStatus.period.SlowCount, systemTotal: vehicleStatus.total.SlowCount },
                    { category: "", item: "", groupColspan: 2, groupRowspan: 1, group: "ABS工作次数", periodTotal: vehicleStatus.period.ABSCount, systemTotal: vehicleStatus.total.ABSCount },
                    { category: "", item: "", groupColspan: 2, groupRowspan: 1, group: "刹车次数", periodTotal: vehicleStatus.period.BrakeCount, systemTotal: vehicleStatus.total.BrakeCount },
                    { category: "", item: "", groupColspan: 2, groupRowspan: 1, group: "近光灯开启次数", periodTotal: vehicleStatus.period.NearLghtCount, systemTotal: vehicleStatus.total.NearLghtCount },
                    { category: "", item: "", groupColspan: 2, groupRowspan: 1, group: "远光灯开启次数", periodTotal: vehicleStatus.period.BeamCount, systemTotal: vehicleStatus.total.BeamCount },
                ];
                if (this.fuelType == 1) {
                    this.tableData3 = [ // 表头行
                        {
                            category: "使用状态",
                            group: "基本项目",
                            item: "",
                            periodTotal: "采集数据",
                            systemTotal: "",
                            isHeader: true
                        },
                        // 采集数据子表头
                        {
                            category: "",
                            item: "",
                            periodTotal: "该时间段累计",
                            systemTotal: "系统总累计",
                            isHeader: true
                        },
                        // 报警故障信息

                        {
                            category: "报警故障信息", categoryRowspan: 24,
                            group: "制动蹄片磨损报警", groupRowspan: 2,
                            item: "次数",
                            periodTotal: vehicleStatus.period.BrakeAlarmCount,
                            systemTotal: vehicleStatus.total.BrakeAlarmCount
                        },
                        {
                            category: "",
                            group: "",
                            item: "时间(hh:mm:ss)",
                            periodTotal: formatDuration(vehicleStatus.period.BrakeAlarmDuration),
                            systemTotal: formatDuration(vehicleStatus.total.BrakeAlarmDuration)
                        },
                        // 空滤堵塞报警
                        {
                            category: "",
                            group: "空滤堵塞报警", groupRowspan: 2,
                            item: "次数",
                            periodTotal: vehicleStatus.period.LeachCount,
                            systemTotal: vehicleStatus.total.LeachCount
                        },
                        {
                            category: "",
                            group: "空滤堵塞报警",
                            item: "时间(hh:mm:ss)",
                            periodTotal: formatDuration(vehicleStatus.period.LeachDuration),
                            systemTotal: formatDuration(vehicleStatus.total.LeachDuration)
                        },
                        // 整车故障次数
                        {
                            category: "",
                            group: "整车故障次数", groupRowspan: 4,
                            item: "1级",
                            periodTotal: vehicleStatus.period.FaultCounts_1,
                            systemTotal: vehicleStatus.total.FaultCounts_1
                        },
                        {
                            category: "",
                            group: "整车故障次数",
                            item: "2级",
                            periodTotal: vehicleStatus.period.FaultCounts_2,
                            systemTotal: vehicleStatus.total.FaultCounts_2
                        },
                        {
                            category: "",
                            group: "整车故障次数",
                            item: "3级",
                            periodTotal: vehicleStatus.period.FaultCounts_3,
                            systemTotal: vehicleStatus.total.FaultCounts_3
                        },
                        {
                            category: "",
                            group: "整车故障次数",
                            item: "4级",
                            periodTotal: vehicleStatus.period.FaultCounts_4,
                            systemTotal: vehicleStatus.total.FaultCounts_4
                        },
                        // BMS故障次数
                        {
                            category: "",
                            group: "BMS故障次数", groupRowspan: 4,
                            item: "1级",
                            periodTotal: vehicleStatus.period.BMSFaultCounts_1,
                            systemTotal: vehicleStatus.total.BMSFaultCounts_1
                        },
                        {
                            category: "",
                            group: "BMS故障次数",
                            item: "2级",
                            periodTotal: vehicleStatus.period.BMSFaultCounts_2,
                            systemTotal: vehicleStatus.total.BMSFaultCounts_2
                        },
                        {
                            category: "",
                            group: "BMS故障次数",
                            item: "3级",
                            periodTotal: vehicleStatus.period.BMSFaultCounts_3,
                            systemTotal: vehicleStatus.total.BMSFaultCounts_3
                        },
                        {
                            category: "",
                            group: "BMS故障次数",
                            item: "4级",
                            periodTotal: vehicleStatus.period.BMSFaultCounts_4,
                            systemTotal: vehicleStatus.total.BMSFaultCounts_4
                        },
                        // 驱动电机故障次数
                        {
                            category: "",
                            group: "驱动电机故障次数", groupRowspan: 4,
                            item: "1级",
                            periodTotal: vehicleStatus.period.DriverElecMachineFaultCounts_1,
                            systemTotal: vehicleStatus.total.DriverElecMachineFaultCounts_1
                        },
                        {
                            category: "",
                            group: "驱动电机故障次数",
                            item: "2级",
                            periodTotal: vehicleStatus.period.DriverElecMachineFaultCounts_2,
                            systemTotal: vehicleStatus.total.DriverElecMachineFaultCounts_2
                        },
                        {
                            category: "",
                            group: "驱动电机故障次数",
                            item: "3级",
                            periodTotal: vehicleStatus.period.DriverElecMachineFaultCounts_3,
                            systemTotal: vehicleStatus.total.DriverElecMachineFaultCounts_3
                        },
                        {
                            category: "",
                            group: "驱动电机故障次数",
                            item: "4级",
                            periodTotal: vehicleStatus.period.DriverElecMachineFaultCounts_4,
                            systemTotal: vehicleStatus.total.DriverElecMachineFaultCounts_4
                        },
                        {
                            category: "",
                            group: "油门故障次数", groupRowspan: 4,
                            item: "1级",
                            periodTotal: vehicleStatus.period.OilGateFaultCounts_1,
                            systemTotal: vehicleStatus.total.OilGateFaultCounts_1
                        },
                        {
                            category: "",
                            group: "油门故障次数",
                            item: "2级",
                            periodTotal: vehicleStatus.period.OilGateFaultCounts_2,
                            systemTotal: vehicleStatus.total.OilGateFaultCounts_2
                        },
                        {
                            category: "",
                            group: "油门故障次数",
                            item: "3级",
                            periodTotal: vehicleStatus.period.OilGateFaultCounts_3,
                            systemTotal: vehicleStatus.total.OilGateFaultCounts_3
                        },
                        {
                            category: "",
                            group: "油门故障次数",
                            item: "4级",
                            periodTotal: vehicleStatus.period.OilGateFaultCounts_4,
                            systemTotal: vehicleStatus.total.OilGateFaultCounts_4
                        },
                        // 气压故障次数
                        {
                            category: "",
                            group: "气压故障次数", groupRowspan: 4,
                            item: "1级",
                            periodTotal: vehicleStatus.period.GasPressFaultCounts_1,
                            systemTotal: vehicleStatus.total.GasPressFaultCounts_1
                        },
                        {
                            category: "",
                            group: "气压故障次数",
                            item: "2级",
                            periodTotal: vehicleStatus.period.GasPressFaultCounts_2,
                            systemTotal: vehicleStatus.total.GasPressFaultCounts_2
                        },
                        {
                            category: "",
                            group: "气压故障次数",
                            item: "3级",
                            periodTotal: vehicleStatus.period.GasPressFaultCounts_3,
                            systemTotal: vehicleStatus.total.GasPressFaultCounts_3
                        },
                        {
                            category: "",
                            group: "气压故障次数",
                            item: "4级",
                            periodTotal: vehicleStatus.period.GasPressFaultCounts_4,
                            systemTotal: vehicleStatus.total.GasPressFaultCounts_4
                        }];
                } else {
                    this.tableData3 = [ // 表头行
                        {
                            category: "使用状态",
                            group: "基本项目",
                            item: "",
                            periodTotal: "采集数据",
                            systemTotal: "",
                            isHeader: true
                        },
                        // 采集数据子表头
                        {
                            category: "",
                            item: "",
                            periodTotal: "该时间段累计",
                            systemTotal: "系统总累计",
                            isHeader: true
                        },
                        // 报警故障信息

                        {
                            category: "报警故障信息", categoryRowspan: 4,
                            group: "制动蹄片磨损报警", groupRowspan: 2,
                            item: "次数",
                            periodTotal: vehicleStatus.period.BrakeAlarmCount,
                            systemTotal: vehicleStatus.total.BrakeAlarmCount
                        },
                        {
                            category: "",
                            group: "",
                            item: "时间(hh:mm:ss)",
                            periodTotal: formatDuration(vehicleStatus.period.BrakeAlarmDuration),
                            systemTotal: formatDuration(vehicleStatus.total.BrakeAlarmDuration)
                        },
                        // 空滤堵塞报警
                        {
                            category: "",
                            group: "空滤堵塞报警", groupRowspan: 2,
                            item: "次数",
                            periodTotal: vehicleStatus.period.LeachCount,
                            systemTotal: vehicleStatus.total.LeachCount
                        },
                        {
                            category: "",
                            group: "空滤堵塞报警",
                            item: "时间(hh:mm:ss)",
                            periodTotal: formatDuration(vehicleStatus.period.LeachDuration),
                            systemTotal: formatDuration(vehicleStatus.total.LeachDuration)
                        },
                    ];
                }
                this.tableData4 = [{
                    category: "使用状态",
                    group: "基本项目",
                    item: "",
                    periodTotal: "采集数据",
                    systemTotal: "",
                    isHeader: true
                },
                // 采集数据子表头
                {
                    category: "",
                    group: "",
                    item: "",
                    periodTotal: "该时间段累计",
                    systemTotal: "系统总累计",
                    isHeader: true
                },
                {
                    category: "驾驶员不良操作", categoryRowspan: this.fuelType == 1 ? 28 : 26,
                    group: "急加速", groupRowspan: 3,
                    item: "次数",
                    periodTotal: vehicleStatus.period.SpeedUpCount,
                    systemTotal: vehicleStatus.total.SpeedUpCount
                },
                { category: "", group: "急加速", item: "时间(hh:mm:ss)", periodTotal: formatDuration(vehicleStatus.period.SpeedUpDuration), systemTotal: formatDuration(vehicleStatus.total.SpeedUpDuration) },
                { category: "", group: "急加速", item: "时间占比", periodTotal: this.calculateDurationRatio(vehicleStatus.period.SpeedUpDuration, vehicleStatus.period.DriveDuration), systemTotal: this.calculateDurationRatio(vehicleStatus.total.SpeedUpDuration, vehicleStatus.total.DriveDuration) },

                // 急减速
                { category: "", group: "急减速", groupRowspan: 3, item: "次数", periodTotal: vehicleStatus.period.SpeedDownCount, systemTotal: vehicleStatus.total.SpeedDownCount },
                { category: "", group: "急减速", item: "时间(hh:mm:ss)", periodTotal: formatDuration(vehicleStatus.period.SpeedDownDuration), systemTotal: formatDuration(vehicleStatus.total.SpeedDownDuration) },
                { category: "", group: "急减速", item: "时间占比", periodTotal: this.calculateDurationRatio(vehicleStatus.period.SpeedDownDuration, vehicleStatus.period.DriveDuration), systemTotal: this.calculateDurationRatio(vehicleStatus.total.SpeedDownDuration, vehicleStatus.total.DriveDuration) },

                // 发动机超转
                { category: "", group: this.fuelType == 1 ? "驱动电机超转" : "发动机超转", groupRowspan: 3, item: "次数", periodTotal: this.fuelType == 1 ? vehicleStatus.period.ElecMachine_OverspeedCounts : vehicleStatus.period.OverEnCount, systemTotal: this.fuelType == 1 ? vehicleStatus.total.ElecMachine_OverspeedCounts : vehicleStatus.total.OverEnCount },
                { category: "", group: this.fuelType == 1 ? "驱动电机超转" : "发动机超转", item: "时间(hh:mm:ss)", periodTotal: formatDuration(this.fuelType == 1 ? vehicleStatus.period.ElecMachine_OverspeedDuration : vehicleStatus.period.OverEnDuration), systemTotal: formatDuration(this.fuelType == 1 ? vehicleStatus.total.ElecMachine_OverspeedDuration : vehicleStatus.total.OverEnDuration) },
                { category: "", group: this.fuelType == 1 ? "驱动电机超转" : "发动机超转", item: "时间占比", periodTotal: this.calculateDurationRatio(this.fuelType == 1 ? vehicleStatus.period.ElecMachine_OverspeedDuration : vehicleStatus.period.OverEnDuration, vehicleStatus.period.DriveDuration), systemTotal: this.calculateDurationRatio(this.fuelType == 1 ? vehicleStatus.total.ElecMachine_OverspeedDuration : vehicleStatus.total.OverEnDuration, vehicleStatus.total.DriveDuration) },


                // 怠速
                { category: "", group: "怠速", groupRowspan: 3, item: "次数", periodTotal: vehicleStatus.period.OverIdleCount, systemTotal: vehicleStatus.total.OverIdleCount },
                { category: "", group: "怠速", item: "时间(hh:mm:ss)", periodTotal: formatDuration(vehicleStatus.period.OverIdleDuration), systemTotal: formatDuration(vehicleStatus.total.OverIdleDuration) },
                { category: "", group: "怠速", item: "时间占比", periodTotal: this.calculateDurationRatio(vehicleStatus.period.OverIdleDuration, vehicleStatus.period.DriveDuration), systemTotal: this.calculateDurationRatio(vehicleStatus.total.OverIdleDuration, vehicleStatus.total.DriveDuration) },

                // 空档滑行
                { category: "", group: "空档滑行", groupRowspan: 3, item: "次数", periodTotal: vehicleStatus.period.SlideCount, systemTotal: vehicleStatus.total.SlideCount },
                { category: "", group: "空档滑行", item: "时间(hh:mm:ss)", periodTotal: formatDuration(vehicleStatus.period.SlideDuration), systemTotal: formatDuration(vehicleStatus.total.SlideDuration) },
                { category: "", group: "空档滑行", item: "时间占比", periodTotal: this.calculateDurationRatio(vehicleStatus.period.SlideDuration, vehicleStatus.period.DriveDuration), systemTotal: this.calculateDurationRatio(vehicleStatus.total.SlideDuration, vehicleStatus.total.DriveDuration) },

                // 怠速开空调
                { category: "", group: "怠速开空调", groupRowspan: 3, item: "次数", periodTotal: vehicleStatus.period.AirIdleCount, systemTotal: vehicleStatus.total.AirIdleCount },
                { category: "", group: "怠速开空调", item: "时间(hh:mm:ss)", periodTotal: formatDuration(vehicleStatus.period.AirIdleDuration), systemTotal: formatDuration(vehicleStatus.total.AirIdleDuration) },
                { category: "", group: "怠速开空调", item: "时间占比", periodTotal: this.calculateDurationRatio(vehicleStatus.period.AirIdleDuration, vehicleStatus.period.DriveDuration), systemTotal: this.calculateDurationRatio(vehicleStatus.total.AirIdleDuration, vehicleStatus.total.DriveDuration) }];

                if (this.fuelType == 1) {
                    this.tableData4.push({ category: "", group: "纯电开空调", groupRowspan: 2, item: "次数", periodTotal: vehicleStatus.period.PureElec_AirConditionCounts, systemTotal: vehicleStatus.total.PureElec_AirConditionCounts });

                    this.tableData4.push({ category: "", group: "纯电开空调", item: "时间(hh:mm:ss)", periodTotal: formatDuration(vehicleStatus.period.PureElec_AirConditionDuration), systemTotal: formatDuration(vehicleStatus.total.PureElec_AirConditionDuration) });
                }

                const newRecords_t = [{ category: "", group: "疲劳驾驶", groupRowspan: 4, item: "次数", periodTotal: vehicleStatus.period.TireCount, systemTotal: vehicleStatus.total.TireCount }, { category: "", group: "疲劳驾驶", item: "时间(hh:mm:ss)", periodTotal: formatDuration(vehicleStatus.period.TireDuration), systemTotal: formatDuration(vehicleStatus.total.TireDuration) },
                { category: "", group: "疲劳驾驶", item: "时间占比", periodTotal: this.calculateDurationRatio(vehicleStatus.period.TireDuration, vehicleStatus.period.DriveDuration), systemTotal: this.calculateDurationRatio(vehicleStatus.total.TireDuration, vehicleStatus.total.DriveDuration) },
                { category: "", group: "疲劳驾驶", item: "里程(km)", periodTotal: vehicleStatus.period.TireMileage, systemTotal: vehicleStatus.total.TireMileage },
                // 二档起步
                { category: "", group: "二档起步", groupRowspan: 1, item: "次数", periodTotal: vehicleStatus.period.SecondGearCount, systemTotal: vehicleStatus.total.SecondGearCount },
                // 冷车驾驶
                { category: "", group: "冷车驾驶", groupRowspan: 1, item: "次数", periodTotal: vehicleStatus.period.ColdRunRCount, systemTotal: vehicleStatus.total.ColdRunRCount },
                // 离合器半联动
                { category: "", group: "离合器半联动", groupRowspan: 1, item: "时间占比", periodTotal: vehicleStatus.period.HalfClutch, systemTotal: "" }]

                this.tableData4.push(...newRecords_t);

                this.tableData5 = [
                    {
                        category: "使用状态",
                        group: "基本项目",
                        periodTotal: "采集数据",
                        systemTotal: "",
                        isHeader: true
                    },
                    // 采集数据子表头
                    {
                        category: "",
                        item: "",
                        periodTotal: "该时间段累计",
                        systemTotal: "系统总累计",
                        isHeader: true
                    },
                    {
                        category: "超速统计", categoryRowspan: 10,
                        group: "总超速信息", groupRowspan: 2,
                        item: "次数",
                        periodTotal: vehicleStatus.period.OverCount1 + vehicleStatus.period.OverCount2 + vehicleStatus.period.OverCount3,
                        systemTotal: vehicleStatus.total.OverCount1 + vehicleStatus.total.OverCount2 + vehicleStatus.total.OverCount3
                    },
                    {
                        category: "", group: "总超速信息", item: "时间(hh:mm:ss)", periodTotal: formatDuration(vehicleStatus.period.OverDuration1 + vehicleStatus.period.OverDuration2 + vehicleStatus.period.OverDuration3), systemTotal:
                            formatDuration(vehicleStatus.total.OverDuration1 + vehicleStatus.total.OverDuration2 + vehicleStatus.total.OverDuration3)
                    },

                    // 电子围栏超速
                    { category: "", group: "电子围栏超速", groupRowspan: 2, item: "次数", periodTotal: vehicleStatus.period.ElecOverSpCount, systemTotal: vehicleStatus.total.ElecOverSpCount },
                    { category: "", group: "电子围栏超速", item: "时间(hh:mm:ss)", periodTotal: formatDuration(vehicleStatus.period.ElecOverSpDuration), systemTotal: formatDuration(vehicleStatus.total.ElecOverSpDuration) },

                    // 超速20%以内
                    { category: "", group: "超速20%以内", groupRowspan: 2, item: "次数", periodTotal: vehicleStatus.period.OverCount1, systemTotal: vehicleStatus.total.OverCount1 },
                    { category: "", group: "超速20%以内", item: "时间(hh:mm:ss)", periodTotal: formatDuration(vehicleStatus.period.OverDuration1), systemTotal: formatDuration(vehicleStatus.total.OverDuration1) },

                    // 超速20%-50%
                    { category: "", group: "超速20%-50%", groupRowspan: 2, item: "次数", periodTotal: vehicleStatus.period.OverCount2, systemTotal: vehicleStatus.total.OverCount2 },
                    { category: "", group: "超速20%-50%", item: "时间(hh:mm:ss)", periodTotal: formatDuration(vehicleStatus.period.OverDuration2), systemTotal: formatDuration(vehicleStatus.total.OverDuration2) },

                    // 超速50%以上
                    { category: "", group: "超速50%以上", groupRowspan: 2, item: "次数", periodTotal: vehicleStatus.period.OverCount3, systemTotal: vehicleStatus.total.OverCount3 },
                    { category: "", group: "超速50%以上", item: "时间(hh:mm:ss)", periodTotal: formatDuration(vehicleStatus.period.OverDuration3), systemTotal: formatDuration(vehicleStatus.total.OverDuration3) }
                ];

                if (this.fuelType == 1) {
                    const newRecords = [{
                        category: "充电分析", categoryRowspan: 3,
                        group: "累计充电", groupRowspan: 3,
                        item: "次数",
                        periodTotal: vehicleStatus.period.BatteryChargingCounts,
                        systemTotal: vehicleStatus.total.BatteryChargingCounts
                    },
                    { category: "", group: "累计充电", item: "时间(hh:mm:ss)", periodTotal: formatDuration(vehicleStatus.period.BatteryChargingDuration), systemTotal: formatDuration(vehicleStatus.total.BatteryChargingDuration) },
                    { category: "", group: "累计充电", item: "电量(kWh)", periodTotal: vehicleStatus.period.BatteryChargingAmount, systemTotal: vehicleStatus.total.BatteryChargingAmount },

                    // 电池状态分析
                    { category: "电池状态分析", categoryRowspan: 5, item: "", groupRowspan: 1, groupColspan: 2, group: "电池单体最低电压", periodTotal: vehicleStatus.period.BatteryMinVoltage, systemTotal: vehicleStatus.total.BatteryMinVoltage },
                    { category: "", group: "电池单体最高电压", item: "", groupRowspan: 1, groupColspan: 2, periodTotal: vehicleStatus.period.BatteryMaxVoltage, systemTotal: vehicleStatus.total.BatteryMaxVoltage },
                    { category: "", group: "电池单体最高温度", item: "", groupRowspan: 1, groupColspan: 2, periodTotal: vehicleStatus.period.BatteryMaxTem, systemTotal: vehicleStatus.total.BatteryMaxTem },
                    { category: "", group: "电池组最高电压", item: "", groupRowspan: 1, groupColspan: 2, periodTotal: vehicleStatus.period.BatterySMaxVoltage, systemTotal: vehicleStatus.total.BatterySMaxVoltage },
                    { category: "", group: "电池组最低电压", item: "", groupRowspan: 1, groupColspan: 2, periodTotal: vehicleStatus.period.BatterySMinvoltage, systemTotal: vehicleStatus.total.BatterySMinvoltage }];

                    this.tableData5.push(...newRecords);
                }

            }
        },

        // 合并单元格方法
        arraySpanMethod({ row, rowIndex, columnIndex }) {
            //第一行
            if (rowIndex == 0) {
                if (columnIndex === 0) {
                    return {
                        rowspan: 2,
                        colspan: 1
                    };
                }

                if (columnIndex === 1) {
                    return {
                        rowspan: 2,
                        colspan: 2
                    };
                } if (columnIndex === 2) {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
                if (columnIndex === 3) {
                    return {
                        rowspan: 1,
                        colspan: 2
                    };
                }
            } else if (rowIndex == 1) {
                if (columnIndex < 3) {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            } else {

                if (columnIndex === 0) {
                    return {
                        rowspan: row.categoryRowspan || 0,
                        colspan: 1
                    };
                }

                if (columnIndex === 1) {
                    return {
                        rowspan: row.groupRowspan || 0,
                        colspan: row.groupColspan || 1
                    };


                }
                if (columnIndex === 2) {
                    if (row.item == '') {
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    } else {
                        return {
                            rowspan: 1,
                            colspan: 1
                        };
                    }
                }

                return {
                    rowspan: 1,
                    colspan: 1
                };
            }


        },
        // 可选：如果需要更精细的单元格样式控制，可添加cell-class-name的处理方法
        tableCellClassName({ row, column, rowIndex, columnIndex }) {
            if (rowIndex == 0 || rowIndex == 1) {
                return "cell-header";
            }
            if (columnIndex == 0 || columnIndex == 1 || columnIndex == 2) {
                return "cell-header";
            }

        }
    }
};
</script>
<style scoped>
.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

/* 表头单元格样式 */
.header-cell {
    background: #f5f7fa;
    font-weight: bold;
}

/* 模块标签单元格样式 */
.module-label-cell {
    background: #f5f7fa;
    font-weight: 500;
}





.note-section {

    background: #ffffff;
    margin-top: 15px;
}

.note-card {
    border: 1px solid #e6e6e6;
}

.note-title {
    font-weight: 500;
    margin-bottom: 8px;
}

.note-content {
    line-height: 1.8;
}

.note-sub-item {
    text-indent: 2em;
    /* 缩进对齐 */
    margin-top: 4px;
}
</style>